import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PrivacySettings from '../components/Privacy/PrivacySettings';

const PrivacySettingsPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy & Cookie Settings
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Manage your privacy preferences and control how we use your data.
        </Typography>
        <PrivacySettings />
      </Box>
    </Container>
  );
};

export default PrivacySettingsPage;